import React, { createContext, useContext } from 'react';
import demandConsult from '../services/demandConsult';

interface IIdDemandContext {
  getIdDemand: (sourceId: string) => any;
}
export const IdDemandContext = createContext<IIdDemandContext>({
  getIdDemand: (sourceId: string) => {},
});
const IdDemandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const getIdDemand = async (sourceId: string): Promise<any> => {
    try {
      let res = await demandConsult.getDemand({ sourceId });
      return res;
    } catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  };
  return (
    <IdDemandContext.Provider
      value={{
        getIdDemand,
      }}
    >
      {children}
    </IdDemandContext.Provider>
  );
};

const useIdDemand = (): IIdDemandContext => {
  const context = useContext(IdDemandContext);
  if (!context) {
    throw new Error('useIdDemand must be used within an IdDemandProvider');
  }
  return context;
};

export { IdDemandProvider, useIdDemand };
